import { OrderLineTypes } from "@repo/database";
import { generateRandomString } from "@repo/utils";
import { addMilliseconds } from "date-fns";
import { useTranslation } from "react-i18next";
import { z } from "zod";

import type { CartItem } from "~/providers/cart-provider";
import { useCartManager } from "~/managers/use-cart-manager";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  useForm,
} from "../ui/form";
import { Input } from "../ui/input";

export default function CartItemCommentForm({
  onClose,
  item,
}: {
  onClose: () => void;
  item: CartItem;
}) {
  const { t } = useTranslation("common");
  const { addToCart } = useCartManager();

  const form = useForm({
    schema: z.object({
      comment: z.string().min(1),
    }),
  });

  const handleSubmit = form.handleSubmit((data) => {
    void addToCart({
      ordered: false,
      printed: false,
      reference: generateRandomString(8),
      type: OrderLineTypes.comment,
      parentReference: item.reference,
      value: 0,
      originalQuantity: 1,
      createdAt: addMilliseconds(item.createdAt, 1),
      quantity: 1,
      name: data.comment,
      vatRate: 0,
    });
    onClose();
  });
  return (
    <Form {...form}>
      <form
        id="order-line-comment-form"
        onSubmit={handleSubmit}
        className="flex flex-col gap-2"
      >
        <FormField
          control={form.control}
          name="comment"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t("Comment.comment")}</FormLabel>
              <FormControl>
                <Input {...field} />
              </FormControl>
            </FormItem>
          )}
        />
      </form>
    </Form>
  );
}
